import React from 'react'
import { EmptyStateTextOnly } from 'src/components/Reusable/Text/EmptyStateTextOnly'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { ControlsListItem } from '../../IndexItem'
import { CONTROL_GRID_LOCATIONS } from './ControlsIndexPage.constants'

export const getControlsGridEmptyState = (
  location?: CONTROL_GRID_LOCATIONS,
): JSX.Element => {
  switch (location) {
    case CONTROL_GRID_LOCATIONS.CONTROLS_INDEX:
      return <NoFilterResults />
    case CONTROL_GRID_LOCATIONS.POLICIES_SHOW:
      return (
        <EmptyStateTextOnly text="No controls support this policy. Set this per control." />
      )
    case CONTROL_GRID_LOCATIONS.REQUESTS_SHOW:
      return (
        <EmptyStateTextOnly text="No controls linked to this request. Try linking one. You can unlink it easily." />
      )
    default:
      return <NoFilterResults />
  }
}

interface ControlGridRowsProps {
  modelIds: string[]
  audit?: AuditRecord
}

export const ControlGridRows = ({
  modelIds,
  audit,
}: ControlGridRowsProps): JSX.Element => (
  <>
    {modelIds.map((id) => (
      <ControlsListItem key={id} controlModelId={id} audit={audit} />
    ))}
  </>
)
